import _, { forEach } from "lodash";
class OptionsInput extends HTMLElement {
  constructor() {
    super();

    this.open = false;
    this.place = this.dataset.place;
    this.options = this.querySelectorAll(".opt");
    this.selected = this.getAttribute("selected_id");
    this.showMore = this.querySelector(".more");
    //this.deactiveUnusedOptions = this.deactiveUnusedOptions.bind(this);
    this.option_type = this.hasAttribute("gallery_relevant");

    /*
    this.input.addEventListener("click", () => {
      this.open = !this.open;
      if (this.open) {
        this.input.classList.add("open");
      } else {
        this.input.classList.remove("open");
      }
    });
    */

    if (this.showMore) {
      this.showMore.classList.add("ready");
      this.showMore.addEventListener("click", () => {
        //console.log("click");
        forEach(this.options, (option) => {
          option.classList.remove("md:hidden");
        });
        this.showMore.classList.add("md:hidden");
      });
    }

    //this.deactiveUnusedOptions();

    /*
    this.input.addEventListener("blur", () => {
      this.open = false;
      this.input.classList.remove("open");
    });

    this.input.addEventListener("keyup", (e) => {
      if (e.code === "Escape") {
        this.open = !this.open;
        if (this.open) {
          this.input.classList.add("open");
        } else {
          this.input.classList.remove("open");
        }
      }
    });
    */

    forEach(this.options, (option) => {
      option.addEventListener("click", () => {
        //console.log("click");
        if (option.hasAttribute("aria-disabled")) {
          return;
        }
        const value = option.getAttribute("value");
        this.setAttribute("selected_id", value);
        deselectOptions(this.place);
        option.ariaSelected = true;
        if (this.option_type) {
          this.querySelector("label span").textContent = value;
        }
        const event = new CustomEvent("onOptionChange", {
          detail: {
            selectedId: value,
            place: this.place,
            optionType: this.option_type,
          },
          bubbles: true,
          cancelable: true,
        });

        this.dispatchEvent(event);
      });
    });

    /*this.input.addEventListener("change", () => {
      this.input.setAttribute("selected_id", this.input.value);
      if (this.place == 1) {
        deactiveUnusedOptions(this.input, this.place);
      } else if (this.place == 2) {
        deactiveUnusedOptions(this.input, this.place);
      }
      if (this.option_type == "Material") {
        document
          .querySelector(
            "input[data-attached_material='" + this.input.value + "']"
          )
          ?.click();
      }
      if (this.input.classList.contains("open")) {
        this.input.classList.remove("open");
      }
    });*/

    function deselectOptions(place) {
      Array.from(
        document.querySelectorAll(
          "options-input[data-place='" + place + "'] div.opt"
        )
      ).forEach(function (element) {
        element.ariaSelected = false;
      });
    }

    /*function deactiveUnusedOptions2(selected, place) {
      const formEl = document.querySelector("product-form");
      console.log("run");
      if (formEl.dataset.variants) {
        let variants = JSON.parse(formEl.dataset.variants);
        const option2 = formEl.querySelector('[data-option="2"]');
        const option3 = formEl.querySelector('[data-option="3"]');

        if (option2 && place == 1) {
          Array.from(option2.querySelectorAll("div.opt")).forEach(function (
            element,
            index
          ) {
            const matchingVariant = _.find(variants, {
              option1: selected,
              option2: element.getAttribute("value") || null,
            });
            console.log(matchingVariant);
            if (matchingVariant) {
              element.removeAttribute("aria-disabled");
            } else {
              element.setAttribute("aria-disabled", "true");
              if (element.getAttribute("aria-selected")) {
                element.ariaSelected = false;
                let newSelected = false;
                Array.from(option2.querySelectorAll("div.opt")).forEach(function (element) {
                  if (element.getAttribute("aria-disabled")!= "true") {
                    if(!newSelected){
                      deselectOptions(place);
                      element.ariaSelected = true;
                      newSelected = true;
                    }
                  }
                });
              }
            }
          });
          if (option2.selectedOptions[0].hasAttribute("disabled")) {
            Array.from(option2.querySelectorAll("div.opt")).forEach(function (element, index) {
              if (!element.hasAttribute("disabled")) {
                option2.selectedIndex = index;
              }
            });
          }
        }
        if (option3) {
          Array.from(option3.options).forEach(function (element, index) {
            let matchingVariant;
            if (place == 1) {
              const option2 = formEl.querySelector('[data-option="2"]');
              matchingVariant = _.find(variants, {
                option1: input.value,
                option2: option2.value,
                option3: element.value || null,
              });
            } else if (place == 2) {
              const option1 = formEl.querySelector('[data-option="1"]');
              matchingVariant = _.find(variants, {
                option1: option1.value,
                option2: input.value,
                option3: element.value || null,
              });
            }
            if (matchingVariant) {
              element.removeAttribute("disabled");
            } else {
              element.setAttribute("disabled", "");
            }
          });
          if (option3.selectedOptions[0].hasAttribute("disabled")) {
            Array.from(option3.options).forEach(function (element, index) {
              if (!element.hasAttribute("disabled")) {
                option3.selectedIndex = index;
              }
            });
          }
        }
      }
    }*/
  }
}

customElements.define("options-input", OptionsInput);
